import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import {tableSortHeader} from "../../../../../components/reports/table-sort-header/table-sort-header.jsx";

const AlarmQuestionsContent = ({ data }) => {
    const questions = data?.tableApply ?? [];
    const searchZeros = (value) => value === 0 ? 'text-[#c4c4c4]' : '';

    useEffect(() => {
        if (questions.length === 0) return;

        const values = [];
        const labels = [
            "Perguntas de alarmes",

            "1ª fase - Total",
            "1ª fase - SIM",
            "1ª fase - NÃO",

            "2ª fase - Total",
            "2ª fase - Corrigido para NÃO",
            "2ª fase - Corrigido para SIM"
        ];

        questions.map((element) => {
            values.push([
                element.question,

                element.total_first,
                element.positive_first,
                element.negative_first,

                element.total_second,
                element.to_negative_second,
                element.to_positive_second,
            ])
        });

        ReportUtils.createExportableTable(labels, values, "Perguntas de alarmes")
    }, [questions]);

    const { order, handleSort, sortedData, getIcon } = tableSortHeader(questions);

    return (
        <>
            <span className="chart-title">Perguntas de alarmes</span>
            { questions.length > 0 ? (
                <>
                    <table id={'alarm-questions-data'} className="table report-table mt-3 mb-4" sheet-name={"Perguntas de alarme"}>
                        <thead className="thead-background">

                            <tr>
                                <th rowSpan={2} className={"transform translate-y-5 border-r border-[#e0e0e0]"}>Perguntas de alarmes</th>
                                <th colSpan={3} className={'border-r border-[#e0e0e0] text-[#606062]'}>Assinados na 1ª fase</th>
                                <th colSpan={3} className={'border-r border-[#e0e0e0] text-[#606062]'}>Assinados na 2ª fase</th>
                            </tr>

                            <tr>
                                <th onClick={() => handleSort('total_first')} style={{ cursor: 'pointer',  borderRight: '1px solid #e0e0e0', userSelect: 'none'  }}> Total {getIcon(order, 'total_first')}</th>
                                <th onClick={() => handleSort('positive_first')} style={{ cursor: 'pointer',  borderRight: '1px solid #e0e0e0', userSelect: 'none'  }}> SIM {getIcon(order, 'positive_first')}</th>
                                <th onClick={() => handleSort('negative_first')} style={{ cursor: 'pointer',  borderRight: '1px solid #e0e0e0', userSelect: 'none'  }}> NÃO {getIcon(order, 'negative_first')}</th>

                                <th onClick={() => handleSort('total_second')} style={{ cursor: 'pointer',  borderRight: '1px solid #e0e0e0', userSelect: 'none'  }}> Total {getIcon(order, 'total_second')}</th>
                                <th onClick={() => handleSort('to_negative_second')} style={{ cursor: 'pointer',  borderRight: '1px solid #e0e0e0', userSelect: 'none'  }}> Corrigido para NÃO {getIcon(order, 'to_negative_second')}</th>
                                <th onClick={() => handleSort('to_positive_second')} style={{ cursor: 'pointer',  borderRight: '1px solid #e0e0e0', userSelect: 'none'  }}> Corrigido para SIM {getIcon(order, 'to_positive_second')}</th>
                            </tr>

                        </thead>

                        <tbody>
                            { sortedData.map((element, index) => (
                                <tr key={index} className={'text-center'}>

                                    <td className={'!text-left'}>{element.question}</td>

                                    <td className={searchZeros(element.total_first)}>{element.total_first}</td>
                                    <td className={searchZeros(element.positive_first)}>{element.positive_first}</td>
                                    <td className={searchZeros(element.negative_first)}>{element.negative_first}</td>

                                    <td className={searchZeros(element.total_second)}>{element.total_second}</td>
                                    <td className={searchZeros(element.to_negative_second)}>{element.to_negative_second}</td>
                                    <td className={searchZeros(element.to_positive_second)}>{element.to_positive_second}</td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            ) : (
                <>
                    <div id="noDataMessage" className={"alert alert-info p-2 h6 text-center"}>
                        Nenhum registro encontrado.
                    </div>
                </>
            )}

            <div className="chart-divisor print:hidden"/>
        </>
    );
};

export default AlarmQuestionsContent;